import React, { Fragment } from "react";

import "./Section.css";
import "../../styles/uikit.css";
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";

class Section extends React.Component {
  constructor(props) {
    super(props);
    this.toggleClass = this.toggleClass.bind(this);
    this.state = { active: new Array(props.categories.length).fill(false) };  
  }


  toggleClass(index) {
    const previousState = [...this.state.active];
    const indexOfTrue = previousState.indexOf(true);
    previousState[indexOfTrue]=false;
    previousState[index]=true;
    this.setState({ active: previousState });
  }

  render() {
    return (
      <Fragment>
            {/* each category level  */}
            <div className="mn-content-categories__wrapper">
              <ul className="mn-content-categories__list">
                {this.props.categories.map((category, i) => {
                  return (
                    <li
                      key={category.code}
                      className={[
                        "mn-content-categories__item",
                        category.hasChildren ? "has-children" : "",
                        this.state.active[i] ? "is-active" : "",
                      ].join(" ")}
                      onClick={() => {
                        this.toggleClass(i);
                        this.props.onSelect(category);
                      }}
                    >
                      <label
                        htmlFor={category.code}
                        className="mn-content-categories__link"
                      >
                        <input
                          type="radio"
                          className="uk-hidden js-category-data"
                          data-id={category.code}
                          value={
                            category.secondName
                              ? category.name + " (" + category.secondName + ")"
                              : category.name
                          }
                          data-theme={category.displayOrder}
                        />
                        {category.secondName
                          ? category.name + " (" + category.secondName + ")"
                          : category.name}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          
      </Fragment>
    );
  }
}

export default Section;
